import { render } from "./References.vue?vue&type=template&id=d8447f78&scoped=true"
import script from "./References.vue?vue&type=script&lang=js"
export * from "./References.vue?vue&type=script&lang=js"

import "./References.vue?vue&type=style&index=0&id=d8447f78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8447f78"]])

export default __exports__